import React from 'react'
import ProductImage from './index'

export const PrincipalProductImage = () => {
  return <ProductImage imageSource="/assets/img/app-logo/principal.png" color="#1f4796" />
}
